/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as ScreenRouteImport } from "./routes/_screen"
import { Route as AppRouteImport } from "./routes/_app"
import { Route as AppIndexRouteImport } from "./routes/_app/index"
import { Route as ScreenTermsRouteImport } from "./routes/_screen/terms"
import { Route as ScreenPrivacyRouteImport } from "./routes/_screen/privacy"
import { Route as ScreenPaymentPolicyRouteImport } from "./routes/_screen/payment-policy"
import { Route as ScreenLegalRouteImport } from "./routes/_screen/legal"
import { Route as ScreenContractRouteImport } from "./routes/_screen/contract"
import { Route as ScreenAboutRouteImport } from "./routes/_screen/about"
import { Route as AppProfileRouteImport } from "./routes/_app/profile"
import { Route as AppManageRouteImport } from "./routes/_app/manage"
import { Route as AppBillingRouteImport } from "./routes/_app/billing"
import { Route as AppAffiliateRouteImport } from "./routes/_app/affiliate"
import { Route as ScreenBlogIndexRouteImport } from "./routes/_screen/blog/index"
import { Route as ScreenSSubmissionRouteImport } from "./routes/_screen/s/submission"
import { Route as ScreenSCampaignRouteImport } from "./routes/_screen/s/campaign"
import { Route as ScreenSAffiliateRouteImport } from "./routes/_screen/s/affiliate"
import { Route as ScreenNotificationIdRouteImport } from "./routes/_screen/notification/$id"
import { Route as ScreenCampaignPreviewRouteImport } from "./routes/_screen/campaign/preview"
import { Route as ScreenCampaignListRouteImport } from "./routes/_screen/campaign/list"
import { Route as ScreenBlogIdRouteImport } from "./routes/_screen/blog/$id"
import { Route as ScreenAffiliateSavedRouteImport } from "./routes/_screen/affiliate/saved"
import { Route as ScreenAffiliateIdRouteImport } from "./routes/_screen/affiliate/$id"
import { Route as ScreenManageChatCodeRouteImport } from "./routes/_screen/manage/chat/$code"
import { Route as ScreenCampaignAffiliateIdRouteImport } from "./routes/_screen/campaign/affiliate.$id"
import { Route as ScreenCampaignAffiliateIdUpdateSkuRouteImport } from "./routes/_screen/campaign/affiliate.$id_.update-sku"

const ScreenRoute = ScreenRouteImport.update({
  id: "/_screen",
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRoute,
} as any)
const ScreenTermsRoute = ScreenTermsRouteImport.update({
  id: "/terms",
  path: "/terms",
  getParentRoute: () => ScreenRoute,
} as any)
const ScreenPrivacyRoute = ScreenPrivacyRouteImport.update({
  id: "/privacy",
  path: "/privacy",
  getParentRoute: () => ScreenRoute,
} as any)
const ScreenPaymentPolicyRoute = ScreenPaymentPolicyRouteImport.update({
  id: "/payment-policy",
  path: "/payment-policy",
  getParentRoute: () => ScreenRoute,
} as any)
const ScreenLegalRoute = ScreenLegalRouteImport.update({
  id: "/legal",
  path: "/legal",
  getParentRoute: () => ScreenRoute,
} as any)
const ScreenContractRoute = ScreenContractRouteImport.update({
  id: "/contract",
  path: "/contract",
  getParentRoute: () => ScreenRoute,
} as any)
const ScreenAboutRoute = ScreenAboutRouteImport.update({
  id: "/about",
  path: "/about",
  getParentRoute: () => ScreenRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => AppRoute,
} as any)
const AppManageRoute = AppManageRouteImport.update({
  id: "/manage",
  path: "/manage",
  getParentRoute: () => AppRoute,
} as any)
const AppBillingRoute = AppBillingRouteImport.update({
  id: "/billing",
  path: "/billing",
  getParentRoute: () => AppRoute,
} as any)
const AppAffiliateRoute = AppAffiliateRouteImport.update({
  id: "/affiliate",
  path: "/affiliate",
  getParentRoute: () => AppRoute,
} as any)
const ScreenBlogIndexRoute = ScreenBlogIndexRouteImport.update({
  id: "/blog/",
  path: "/blog/",
  getParentRoute: () => ScreenRoute,
} as any)
const ScreenSSubmissionRoute = ScreenSSubmissionRouteImport.update({
  id: "/s/submission",
  path: "/s/submission",
  getParentRoute: () => ScreenRoute,
} as any)
const ScreenSCampaignRoute = ScreenSCampaignRouteImport.update({
  id: "/s/campaign",
  path: "/s/campaign",
  getParentRoute: () => ScreenRoute,
} as any)
const ScreenSAffiliateRoute = ScreenSAffiliateRouteImport.update({
  id: "/s/affiliate",
  path: "/s/affiliate",
  getParentRoute: () => ScreenRoute,
} as any)
const ScreenNotificationIdRoute = ScreenNotificationIdRouteImport.update({
  id: "/notification/$id",
  path: "/notification/$id",
  getParentRoute: () => ScreenRoute,
} as any)
const ScreenCampaignPreviewRoute = ScreenCampaignPreviewRouteImport.update({
  id: "/campaign/preview",
  path: "/campaign/preview",
  getParentRoute: () => ScreenRoute,
} as any)
const ScreenCampaignListRoute = ScreenCampaignListRouteImport.update({
  id: "/campaign/list",
  path: "/campaign/list",
  getParentRoute: () => ScreenRoute,
} as any)
const ScreenBlogIdRoute = ScreenBlogIdRouteImport.update({
  id: "/blog/$id",
  path: "/blog/$id",
  getParentRoute: () => ScreenRoute,
} as any)
const ScreenAffiliateSavedRoute = ScreenAffiliateSavedRouteImport.update({
  id: "/affiliate/saved",
  path: "/affiliate/saved",
  getParentRoute: () => ScreenRoute,
} as any)
const ScreenAffiliateIdRoute = ScreenAffiliateIdRouteImport.update({
  id: "/affiliate/$id",
  path: "/affiliate/$id",
  getParentRoute: () => ScreenRoute,
} as any)
const ScreenManageChatCodeRoute = ScreenManageChatCodeRouteImport.update({
  id: "/manage/chat/$code",
  path: "/manage/chat/$code",
  getParentRoute: () => ScreenRoute,
} as any)
const ScreenCampaignAffiliateIdRoute =
  ScreenCampaignAffiliateIdRouteImport.update({
    id: "/campaign/affiliate/$id",
    path: "/campaign/affiliate/$id",
    getParentRoute: () => ScreenRoute,
  } as any)
const ScreenCampaignAffiliateIdUpdateSkuRoute =
  ScreenCampaignAffiliateIdUpdateSkuRouteImport.update({
    id: "/campaign/affiliate/$id_/update-sku",
    path: "/campaign/affiliate/$id/update-sku",
    getParentRoute: () => ScreenRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof AppIndexRoute
  "/affiliate": typeof AppAffiliateRoute
  "/billing": typeof AppBillingRoute
  "/manage": typeof AppManageRoute
  "/profile": typeof AppProfileRoute
  "/about": typeof ScreenAboutRoute
  "/contract": typeof ScreenContractRoute
  "/legal": typeof ScreenLegalRoute
  "/payment-policy": typeof ScreenPaymentPolicyRoute
  "/privacy": typeof ScreenPrivacyRoute
  "/terms": typeof ScreenTermsRoute
  "/affiliate/$id": typeof ScreenAffiliateIdRoute
  "/affiliate/saved": typeof ScreenAffiliateSavedRoute
  "/blog/$id": typeof ScreenBlogIdRoute
  "/campaign/list": typeof ScreenCampaignListRoute
  "/campaign/preview": typeof ScreenCampaignPreviewRoute
  "/notification/$id": typeof ScreenNotificationIdRoute
  "/s/affiliate": typeof ScreenSAffiliateRoute
  "/s/campaign": typeof ScreenSCampaignRoute
  "/s/submission": typeof ScreenSSubmissionRoute
  "/blog/": typeof ScreenBlogIndexRoute
  "/campaign/affiliate/$id": typeof ScreenCampaignAffiliateIdRoute
  "/manage/chat/$code": typeof ScreenManageChatCodeRoute
  "/campaign/affiliate/$id/update-sku": typeof ScreenCampaignAffiliateIdUpdateSkuRoute
}
export interface FileRoutesByTo {
  "/": typeof AppIndexRoute
  "/affiliate": typeof AppAffiliateRoute
  "/billing": typeof AppBillingRoute
  "/manage": typeof AppManageRoute
  "/profile": typeof AppProfileRoute
  "/about": typeof ScreenAboutRoute
  "/contract": typeof ScreenContractRoute
  "/legal": typeof ScreenLegalRoute
  "/payment-policy": typeof ScreenPaymentPolicyRoute
  "/privacy": typeof ScreenPrivacyRoute
  "/terms": typeof ScreenTermsRoute
  "/affiliate/$id": typeof ScreenAffiliateIdRoute
  "/affiliate/saved": typeof ScreenAffiliateSavedRoute
  "/blog/$id": typeof ScreenBlogIdRoute
  "/campaign/list": typeof ScreenCampaignListRoute
  "/campaign/preview": typeof ScreenCampaignPreviewRoute
  "/notification/$id": typeof ScreenNotificationIdRoute
  "/s/affiliate": typeof ScreenSAffiliateRoute
  "/s/campaign": typeof ScreenSCampaignRoute
  "/s/submission": typeof ScreenSSubmissionRoute
  "/blog": typeof ScreenBlogIndexRoute
  "/campaign/affiliate/$id": typeof ScreenCampaignAffiliateIdRoute
  "/manage/chat/$code": typeof ScreenManageChatCodeRoute
  "/campaign/affiliate/$id/update-sku": typeof ScreenCampaignAffiliateIdUpdateSkuRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_app": typeof AppRouteWithChildren
  "/_screen": typeof ScreenRouteWithChildren
  "/_app/affiliate": typeof AppAffiliateRoute
  "/_app/billing": typeof AppBillingRoute
  "/_app/manage": typeof AppManageRoute
  "/_app/profile": typeof AppProfileRoute
  "/_screen/about": typeof ScreenAboutRoute
  "/_screen/contract": typeof ScreenContractRoute
  "/_screen/legal": typeof ScreenLegalRoute
  "/_screen/payment-policy": typeof ScreenPaymentPolicyRoute
  "/_screen/privacy": typeof ScreenPrivacyRoute
  "/_screen/terms": typeof ScreenTermsRoute
  "/_app/": typeof AppIndexRoute
  "/_screen/affiliate/$id": typeof ScreenAffiliateIdRoute
  "/_screen/affiliate/saved": typeof ScreenAffiliateSavedRoute
  "/_screen/blog/$id": typeof ScreenBlogIdRoute
  "/_screen/campaign/list": typeof ScreenCampaignListRoute
  "/_screen/campaign/preview": typeof ScreenCampaignPreviewRoute
  "/_screen/notification/$id": typeof ScreenNotificationIdRoute
  "/_screen/s/affiliate": typeof ScreenSAffiliateRoute
  "/_screen/s/campaign": typeof ScreenSCampaignRoute
  "/_screen/s/submission": typeof ScreenSSubmissionRoute
  "/_screen/blog/": typeof ScreenBlogIndexRoute
  "/_screen/campaign/affiliate/$id": typeof ScreenCampaignAffiliateIdRoute
  "/_screen/manage/chat/$code": typeof ScreenManageChatCodeRoute
  "/_screen/campaign/affiliate/$id_/update-sku": typeof ScreenCampaignAffiliateIdUpdateSkuRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/affiliate"
    | "/billing"
    | "/manage"
    | "/profile"
    | "/about"
    | "/contract"
    | "/legal"
    | "/payment-policy"
    | "/privacy"
    | "/terms"
    | "/affiliate/$id"
    | "/affiliate/saved"
    | "/blog/$id"
    | "/campaign/list"
    | "/campaign/preview"
    | "/notification/$id"
    | "/s/affiliate"
    | "/s/campaign"
    | "/s/submission"
    | "/blog/"
    | "/campaign/affiliate/$id"
    | "/manage/chat/$code"
    | "/campaign/affiliate/$id/update-sku"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/affiliate"
    | "/billing"
    | "/manage"
    | "/profile"
    | "/about"
    | "/contract"
    | "/legal"
    | "/payment-policy"
    | "/privacy"
    | "/terms"
    | "/affiliate/$id"
    | "/affiliate/saved"
    | "/blog/$id"
    | "/campaign/list"
    | "/campaign/preview"
    | "/notification/$id"
    | "/s/affiliate"
    | "/s/campaign"
    | "/s/submission"
    | "/blog"
    | "/campaign/affiliate/$id"
    | "/manage/chat/$code"
    | "/campaign/affiliate/$id/update-sku"
  id:
    | "__root__"
    | "/_app"
    | "/_screen"
    | "/_app/affiliate"
    | "/_app/billing"
    | "/_app/manage"
    | "/_app/profile"
    | "/_screen/about"
    | "/_screen/contract"
    | "/_screen/legal"
    | "/_screen/payment-policy"
    | "/_screen/privacy"
    | "/_screen/terms"
    | "/_app/"
    | "/_screen/affiliate/$id"
    | "/_screen/affiliate/saved"
    | "/_screen/blog/$id"
    | "/_screen/campaign/list"
    | "/_screen/campaign/preview"
    | "/_screen/notification/$id"
    | "/_screen/s/affiliate"
    | "/_screen/s/campaign"
    | "/_screen/s/submission"
    | "/_screen/blog/"
    | "/_screen/campaign/affiliate/$id"
    | "/_screen/manage/chat/$code"
    | "/_screen/campaign/affiliate/$id_/update-sku"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ScreenRoute: typeof ScreenRouteWithChildren
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_screen": {
      id: "/_screen"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof ScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app": {
      id: "/_app"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/": {
      id: "/_app/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_screen/terms": {
      id: "/_screen/terms"
      path: "/terms"
      fullPath: "/terms"
      preLoaderRoute: typeof ScreenTermsRouteImport
      parentRoute: typeof ScreenRoute
    }
    "/_screen/privacy": {
      id: "/_screen/privacy"
      path: "/privacy"
      fullPath: "/privacy"
      preLoaderRoute: typeof ScreenPrivacyRouteImport
      parentRoute: typeof ScreenRoute
    }
    "/_screen/payment-policy": {
      id: "/_screen/payment-policy"
      path: "/payment-policy"
      fullPath: "/payment-policy"
      preLoaderRoute: typeof ScreenPaymentPolicyRouteImport
      parentRoute: typeof ScreenRoute
    }
    "/_screen/legal": {
      id: "/_screen/legal"
      path: "/legal"
      fullPath: "/legal"
      preLoaderRoute: typeof ScreenLegalRouteImport
      parentRoute: typeof ScreenRoute
    }
    "/_screen/contract": {
      id: "/_screen/contract"
      path: "/contract"
      fullPath: "/contract"
      preLoaderRoute: typeof ScreenContractRouteImport
      parentRoute: typeof ScreenRoute
    }
    "/_screen/about": {
      id: "/_screen/about"
      path: "/about"
      fullPath: "/about"
      preLoaderRoute: typeof ScreenAboutRouteImport
      parentRoute: typeof ScreenRoute
    }
    "/_app/profile": {
      id: "/_app/profile"
      path: "/profile"
      fullPath: "/profile"
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/manage": {
      id: "/_app/manage"
      path: "/manage"
      fullPath: "/manage"
      preLoaderRoute: typeof AppManageRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/billing": {
      id: "/_app/billing"
      path: "/billing"
      fullPath: "/billing"
      preLoaderRoute: typeof AppBillingRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/affiliate": {
      id: "/_app/affiliate"
      path: "/affiliate"
      fullPath: "/affiliate"
      preLoaderRoute: typeof AppAffiliateRouteImport
      parentRoute: typeof AppRoute
    }
    "/_screen/blog/": {
      id: "/_screen/blog/"
      path: "/blog"
      fullPath: "/blog/"
      preLoaderRoute: typeof ScreenBlogIndexRouteImport
      parentRoute: typeof ScreenRoute
    }
    "/_screen/s/submission": {
      id: "/_screen/s/submission"
      path: "/s/submission"
      fullPath: "/s/submission"
      preLoaderRoute: typeof ScreenSSubmissionRouteImport
      parentRoute: typeof ScreenRoute
    }
    "/_screen/s/campaign": {
      id: "/_screen/s/campaign"
      path: "/s/campaign"
      fullPath: "/s/campaign"
      preLoaderRoute: typeof ScreenSCampaignRouteImport
      parentRoute: typeof ScreenRoute
    }
    "/_screen/s/affiliate": {
      id: "/_screen/s/affiliate"
      path: "/s/affiliate"
      fullPath: "/s/affiliate"
      preLoaderRoute: typeof ScreenSAffiliateRouteImport
      parentRoute: typeof ScreenRoute
    }
    "/_screen/notification/$id": {
      id: "/_screen/notification/$id"
      path: "/notification/$id"
      fullPath: "/notification/$id"
      preLoaderRoute: typeof ScreenNotificationIdRouteImport
      parentRoute: typeof ScreenRoute
    }
    "/_screen/campaign/preview": {
      id: "/_screen/campaign/preview"
      path: "/campaign/preview"
      fullPath: "/campaign/preview"
      preLoaderRoute: typeof ScreenCampaignPreviewRouteImport
      parentRoute: typeof ScreenRoute
    }
    "/_screen/campaign/list": {
      id: "/_screen/campaign/list"
      path: "/campaign/list"
      fullPath: "/campaign/list"
      preLoaderRoute: typeof ScreenCampaignListRouteImport
      parentRoute: typeof ScreenRoute
    }
    "/_screen/blog/$id": {
      id: "/_screen/blog/$id"
      path: "/blog/$id"
      fullPath: "/blog/$id"
      preLoaderRoute: typeof ScreenBlogIdRouteImport
      parentRoute: typeof ScreenRoute
    }
    "/_screen/affiliate/saved": {
      id: "/_screen/affiliate/saved"
      path: "/affiliate/saved"
      fullPath: "/affiliate/saved"
      preLoaderRoute: typeof ScreenAffiliateSavedRouteImport
      parentRoute: typeof ScreenRoute
    }
    "/_screen/affiliate/$id": {
      id: "/_screen/affiliate/$id"
      path: "/affiliate/$id"
      fullPath: "/affiliate/$id"
      preLoaderRoute: typeof ScreenAffiliateIdRouteImport
      parentRoute: typeof ScreenRoute
    }
    "/_screen/manage/chat/$code": {
      id: "/_screen/manage/chat/$code"
      path: "/manage/chat/$code"
      fullPath: "/manage/chat/$code"
      preLoaderRoute: typeof ScreenManageChatCodeRouteImport
      parentRoute: typeof ScreenRoute
    }
    "/_screen/campaign/affiliate/$id": {
      id: "/_screen/campaign/affiliate/$id"
      path: "/campaign/affiliate/$id"
      fullPath: "/campaign/affiliate/$id"
      preLoaderRoute: typeof ScreenCampaignAffiliateIdRouteImport
      parentRoute: typeof ScreenRoute
    }
    "/_screen/campaign/affiliate/$id_/update-sku": {
      id: "/_screen/campaign/affiliate/$id_/update-sku"
      path: "/campaign/affiliate/$id/update-sku"
      fullPath: "/campaign/affiliate/$id/update-sku"
      preLoaderRoute: typeof ScreenCampaignAffiliateIdUpdateSkuRouteImport
      parentRoute: typeof ScreenRoute
    }
  }
}

interface AppRouteChildren {
  AppAffiliateRoute: typeof AppAffiliateRoute
  AppBillingRoute: typeof AppBillingRoute
  AppManageRoute: typeof AppManageRoute
  AppProfileRoute: typeof AppProfileRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAffiliateRoute: AppAffiliateRoute,
  AppBillingRoute: AppBillingRoute,
  AppManageRoute: AppManageRoute,
  AppProfileRoute: AppProfileRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface ScreenRouteChildren {
  ScreenAboutRoute: typeof ScreenAboutRoute
  ScreenContractRoute: typeof ScreenContractRoute
  ScreenLegalRoute: typeof ScreenLegalRoute
  ScreenPaymentPolicyRoute: typeof ScreenPaymentPolicyRoute
  ScreenPrivacyRoute: typeof ScreenPrivacyRoute
  ScreenTermsRoute: typeof ScreenTermsRoute
  ScreenAffiliateIdRoute: typeof ScreenAffiliateIdRoute
  ScreenAffiliateSavedRoute: typeof ScreenAffiliateSavedRoute
  ScreenBlogIdRoute: typeof ScreenBlogIdRoute
  ScreenCampaignListRoute: typeof ScreenCampaignListRoute
  ScreenCampaignPreviewRoute: typeof ScreenCampaignPreviewRoute
  ScreenNotificationIdRoute: typeof ScreenNotificationIdRoute
  ScreenSAffiliateRoute: typeof ScreenSAffiliateRoute
  ScreenSCampaignRoute: typeof ScreenSCampaignRoute
  ScreenSSubmissionRoute: typeof ScreenSSubmissionRoute
  ScreenBlogIndexRoute: typeof ScreenBlogIndexRoute
  ScreenCampaignAffiliateIdRoute: typeof ScreenCampaignAffiliateIdRoute
  ScreenManageChatCodeRoute: typeof ScreenManageChatCodeRoute
  ScreenCampaignAffiliateIdUpdateSkuRoute: typeof ScreenCampaignAffiliateIdUpdateSkuRoute
}

const ScreenRouteChildren: ScreenRouteChildren = {
  ScreenAboutRoute: ScreenAboutRoute,
  ScreenContractRoute: ScreenContractRoute,
  ScreenLegalRoute: ScreenLegalRoute,
  ScreenPaymentPolicyRoute: ScreenPaymentPolicyRoute,
  ScreenPrivacyRoute: ScreenPrivacyRoute,
  ScreenTermsRoute: ScreenTermsRoute,
  ScreenAffiliateIdRoute: ScreenAffiliateIdRoute,
  ScreenAffiliateSavedRoute: ScreenAffiliateSavedRoute,
  ScreenBlogIdRoute: ScreenBlogIdRoute,
  ScreenCampaignListRoute: ScreenCampaignListRoute,
  ScreenCampaignPreviewRoute: ScreenCampaignPreviewRoute,
  ScreenNotificationIdRoute: ScreenNotificationIdRoute,
  ScreenSAffiliateRoute: ScreenSAffiliateRoute,
  ScreenSCampaignRoute: ScreenSCampaignRoute,
  ScreenSSubmissionRoute: ScreenSSubmissionRoute,
  ScreenBlogIndexRoute: ScreenBlogIndexRoute,
  ScreenCampaignAffiliateIdRoute: ScreenCampaignAffiliateIdRoute,
  ScreenManageChatCodeRoute: ScreenManageChatCodeRoute,
  ScreenCampaignAffiliateIdUpdateSkuRoute:
    ScreenCampaignAffiliateIdUpdateSkuRoute,
}

const ScreenRouteWithChildren =
  ScreenRoute._addFileChildren(ScreenRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ScreenRoute: ScreenRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
